var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#0088BF","fillRule":"nonzero"},[React.createElement("path",{"d":"M19 5h-6V3h8v8h-2z","key":0}),React.createElement("path",{"d":"M19.125 3.293l1.414 1.414-7.832 7.832-1.414-1.414z","key":1}),React.createElement("path",{"d":"M17 13.102h2V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h5.021v2H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-4.898z","key":2})]));
}

ExternalLink.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
